import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "m22 12-4-4v3H3v2h15v3l4-4z"
}), 'TrendingFlatSharp');